const MS_IN_DAY = 86400000;

export function expiredListingType(deactivatedAt, { expiredDays = 14 } = {}) {
  if (!deactivatedAt) {
    return false;
  }

  const today = new Date().getTime();
  const expired = new Date(deactivatedAt).getTime();
  const threshold = new Date(expired + expiredDays * MS_IN_DAY).getTime();

  if (threshold < today) {
    return true;
  }
  return false;
}

export function dateToText(date) {
  return date ? new Date(date).toLocaleString() : '-';
}
